import { InjectionToken } from '@angular/core';

export const FEATURES_LIB_CONFIG = new InjectionToken(
  'FEATURES_LIB_CONFIG'
);
